import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const SelectionSkeleton = () => {
  const skeletonItems = Array.from({ length: 18 }); // total number of goal cards

  return (
    <div style={{ padding: "1rem" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "1rem",
        }}
      >
        {skeletonItems.map((_, index) => (
         <div key={index} style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "80px" }}></div>
        </div>
        ))}
      </div>
    </div>
  );
};
